module.exports = __webpack_public_path__ + "static/media/app_store_coming_soon.e1d36b45.png";